module.exports = __webpack_public_path__ + "img/completion5.266a2188.svg";